import { SOURCING_EVENTS_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/sourcing_events_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator([
	'sourcingEventsOverview',
	'sourcingEventsCalendarEvents',
]);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
